/* eslint-disable no-console */
// import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Divider, Flex, Row} from 'antd';
import React, {useEffect, useState} from 'react';
// import PieChartMulti from '../../../../components/Chart/PieCharts/PieChartMulti';
// import {FacilityKey} from '../../../../components/Forms/Constants/IP/FacilityKeyLabel';
// import {filterSelectOptions} from '../../../../components/Forms/Utils/commonFunctions';

import SemiDonutChart from '../../../../components/Chart/PieCharts/SemiDonutChart';
import PageContent from '../../../../components/PageContent/PageContent';
// import {ISelect} from '../../../../interface/ISelect';
// import Tabs from '../../../../components/Tabs/Tabs';
// import {Itabs} from '../../../../interface/Tab';
// import listOfActivity from '../../../../services/modules/DASHBOARD/listOfActivity';
// import {getUniqueArray} from '../../../../shared/commonFunctions';
// import useJSONStore from '../../../../store/St aticJson/jsonStore';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
// import mapAndFilter from '../../../../utils/mapCountry';
import MainTableTitle from '../../../../components/Table/Utils/MainTableTitle';
import sumTableValue from '../../../../components/Table/Utils/sumTableValue';
import Tabs from '../../../../components/Tabs/Tabs';
import {Itabs} from '../../../../interface/Tab';
// import {buildMonthwiseScopeEmissions} from '../../../../services/modules/DASHBOARD/monthwiseEmissions';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {formatIndian} from '../../../../utils/formatIndian';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';

import ActivityPerformance from './ActivityPerformance';
import {SCOPE_COLORS} from './constants/commonConstants';
import {formatListOfActivity} from './constants/commonFunctions';
import IndustryBenchmarks from './IndustryBenchmarks/IndustryBenchmarks';
import MonthwiseSustainabilityPerformance from './MonthwiseSustainabilityPerformance';
import ReductionChart from './ReductionChart';
import Scope from './Scope';
import ScopeLegend from './ScopeLegend';
import YearOnYearSustainabilityPerformance from './YearOnYearSustainabilityPerformance';

const ListOfActivities: React.FC<{
  data: any;
  industryBenchmarksData: any;
  selectedYear: string;
  activityData: any;
  refreshKey?: boolean;
}> = ({
  data,
  industryBenchmarksData,
  selectedYear,
  activityData,
  refreshKey = false
}) => {
  const [renderData, setRenderData] = useState<any>();
  const isScope3Blocked = shouldBlockModuleAccess(accessModule.scope3);
  const totalGhGScopeSource = isScope3Blocked
    ? (renderData?.SCOPE ?? []).filter((_: any, index: number) => index !== 2)
    : renderData?.SCOPE ?? [];

  const semiDonutData = totalGhGScopeSource
    .map((scopeItem: any, index: number) => {
      const total = sumTableValue(
        scopeItem?.data ?? [],
        'value',
        false
      ) as number;

      return {
        name: scopeItem?.label ?? `Scope ${index + 1}`,
        value: Number(Number(total).toFixed(2)),
        fill: SCOPE_COLORS[index + 1]?.progress ?? scopeItem?.color
      };
    })
    .filter((item: {value: number}) => item.value > 0);

  const scopeSource = totalGhGScopeSource;
  const scopeLegendData = scopeSource.map((scopeItem: any, index: number) => {
    const total = sumTableValue(
      scopeItem?.data ?? [],
      'value',
      false
    ) as number;

    return {
      name: scopeItem?.label ?? `Scope ${index + 1}`,
      value: Number(Number(total).toFixed(2)),
      fill: SCOPE_COLORS[index + 1]?.progress ?? scopeItem?.color
    };
  });

  // The trend now loads the year-on-year totals itself and spreads them / 12.
  // const monthwiseData = React.useMemo(
  //   () => buildMonthwiseScopeEmissions(data?.facilityData),
  //   [data]
  // );

  const totalEmissions = (renderData?.SCOPE ?? []).reduce(
    (sum: number, item: any) =>
      sum + (sumTableValue(item?.data ?? [], 'value', false) as number),
    0
  );

  // const {country, states} = useJSONStore.getState();

  useEffect(() => {
    setRenderData(
      formatListOfActivity(
        [...(data?.facilityData ?? []), ...(data?.companyData ?? [])],
        shouldBlockModuleAccess(accessModule.scope3)
      ) ?? []
    );
  }, [data]);

  const getScopeAccess = (scopeName: any) => {
    if (scopeName === 'scope1') {
      return accessModule.scope1;
    } else if (scopeName === 'scope2') {
      return accessModule.scope2;
    } else {
      return accessModule.scope3;
    }
  };

  return (
    <Flex className="LAContainerFlex">
      <PageContent>
        <MainTableTitle title="Overview" showDivider={true} />
        <IndustryBenchmarks
          emissionsData={industryBenchmarksData?.emissionsData}
          intensityData={industryBenchmarksData?.intensityData}
          consumptionData={industryBenchmarksData?.consumptionData}
          selectedYear={selectedYear}
        />
        <ActivityPerformance data={activityData} />
        <Flex className="facilityOverviewTitle">Scope Overview</Flex>
        <Row gutter={[20, 20]} className="LARow">
          <Col span={10}>
            <Flex
              className="totalGHGEmissionsCard"
              style={{
                borderRadius: '16px',
                border: '1px solid #D2D4DA',
                padding: '18px'
              }}
              vertical
              justify="space-between"
            >
              <Flex className="totalGHGEmissionsTitle">
                Total GHG Emissions
              </Flex>
              <Divider />
              <div className="totalGHGEmissionsChartWrap">
                <div className="totalGHGEmissionsChartContainer">
                  <SemiDonutChart
                    data={semiDonutData}
                    showLabel={false}
                    noStrokeWidth
                    centerLabel={{
                      title: 'Total Emissions',
                      value: `${formatIndian(
                        Number(totalEmissions.toFixed(2))
                      )}`,
                      unit: 'tCO2e'
                    }}
                  />
                </div>
              </div>
              <ScopeLegend items={scopeLegendData} unit="tCO2e" />
            </Flex>
          </Col>
          <Col span={14}>
            <Flex
              style={{
                borderRadius: '16px',
                border: '1px solid #D2D4DA',
                padding: '0px 18px'
              }}
            >
              <Tabs
                array={(() => {
                  return (renderData?.SCOPE ?? []).map(
                    (item: any, index: number): Itabs => ({
                      id: `scope-${index + 1}`,
                      name: `Scope ${index + 1}`,
                      component: (
                        <Scope
                          scopeData={item?.data}
                          scopeNumber={index + 1}
                          isBlock={shouldBlockModuleAccess(
                            getScopeAccess(`scope${index + 1}`)
                          )}
                          totalEmissions={totalEmissions}
                        />
                      )
                    })
                  );
                })()}
                type="line"
                className="scopeTabs"
              />
            </Flex>
          </Col>
          <Col span={24}>
            <YearOnYearSustainabilityPerformance
              selectedYear={selectedYear}
              refreshKey={refreshKey}
            />
          </Col>
          <Col span={24}>
            <MonthwiseSustainabilityPerformance
              selectedYear={selectedYear}
              refreshKey={refreshKey}
            />
          </Col>
          <Col span={24}>
            <Flex className="reductionRoadMapContainer" vertical>
              <Flex className="facilityOverviewTitle">Reduction Road Map</Flex>
              <ReductionChart
                selectedYear={selectedYear}
                reductionData={industryBenchmarksData?.reductionData}
                reductionTimelineData={
                  industryBenchmarksData?.reductionTimelineData
                }
              />
            </Flex>
          </Col>
        </Row>
      </PageContent>
    </Flex>
  );
};

export default ListOfActivities;
